export const ADD_TEXT_WORD_LIMIT = 1000;

export const getWords = (value: string) => {
  const trimmedValue = value.trim();
  return trimmedValue ? trimmedValue.split(/\s+/) : [];
};

export const limitWords = (value: string) => {
  const words = getWords(value);

  if (words.length <= ADD_TEXT_WORD_LIMIT) return value;

  return words.slice(0, ADD_TEXT_WORD_LIMIT).join(" ");
};
